<template>
  <div class="active-value">
    <el-row :gutter="50">
      <el-col :span="7">
        <h1>我的活跃值</h1>
        <div class="value">
          <img src="@/assets/活跃值.png" alt />
          {{my.activeValue.value}}
        </div>
      </el-col>
      <el-col :span="17">
        <h1>活跃值统计</h1>
        <el-row :gutter="50">
          <el-col :span="5">
            <h2>+ {{my.activeValue.login}}</h2>
            <div class="login">
              <img src="@/assets/登录奖励.png" alt />登录奖励
            </div>
          </el-col>
          <el-col :span="1">
            <div class="divider"></div>
          </el-col>
          <el-col :span="5">
            <h2>+ {{my.activeValue.interactive}}</h2>
            <div class="interactive">
              <img src="@/assets/互动奖励.png" alt />互动奖励
            </div>
          </el-col>
          <el-col :span="1">
            <div class="divider"></div>
          </el-col>
          <el-col :span="5">
            <h2>+ {{my.activeValue.view}}</h2>
            <div class="view">
              <img src="@/assets/浏览奖励.png" alt /> 浏览量奖励
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <h1>最近一个月活跃值明细</h1>
    <el-table
      :data="more ? my.activeValue.list : my.activeValue.list.slice(0, 10)"
      style="width: 100%"
      header-cell-class-name="my-header-cell"
      header-row-class-name="my-header-row"
      row-class-name="my-row"
      cell-class-name="my-cell"
    >
      <el-table-column label="时间" width="250px">
        <template slot-scope="scope">{{util.toDateTimeString(new Date(scope.row.createTime))}}</template>
      </el-table-column>
      <el-table-column label="收入">
        <template slot-scope="scope">
          <div style="color: #1B994F">+{{scope.row.commit}}</div>
        </template>
      </el-table-column>
      <el-table-column label="说明">
        <template slot-scope="scope">
          <div style="text-align: right">{{scope.row.comment}}</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="more" v-if="!more" @click="more = true">
      展开全部
      <img src="@/assets/展示全部.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "MyActiveValue",
  props: ["my"],
  data() {
    return {
      more: false
    };
  }
};
</script>


<style lang="less">
.active-value {
  .my-header-cell {
    background: #94a49b;
    color: white;

    font-size: 12px;
    padding: 0;
    height: 40px;
  }
  .my-header-cell:nth-child(3) {
    text-align: right;
  }
  .my-cell {
    border: 0;
    padding: 0;
    height: 40px;
    font-size: 12px;
  }
  .my-row:nth-child(2n - 1) {
    background: #f7faf8;
  }

  .more {
    text-align: center;
    color: #1b994f;
    cursor: pointer;
    font-size: 12px;
    margin: 10px 0;
    height: 12px;
    line-height: 12px;

    img {
      height: 8px;
      margin-left: 5px;
      vertical-align: top;
      margin-top: 2px;
    }
  }
}
</style>

<style lang="less" scoped>
.active-value {
  background: white;

  padding: 60px;

  .value {
    background: #f4f4f4;
    border-radius: 10px;

    height: 90px;
    line-height: 90px;

    // text-align: center;

    font-size: 40px;

    img {
      width: 22px;
      margin-left: 20px;
    }
  }

  .divider {
    width: 1px;
    margin: 20px 0;
    height: 50px;
    background: rgba(244, 244, 244, 1);
  }

  .login,
  .interactive,
  .view {
    height: 20px;
    line-height: 20px;
    font-size: 13px;
    color: #333;
    img {
      width: 20px;

      vertical-align: top;
      margin-right: 5px;
    }
  }
}
</style>

